import { HttpClient } from '@angular/common/http';
import { IAppResult } from '@app/core/model/appresults/appresult';
import { BsApiEndPoints } from '@app/core/services/bs-api/endpoints';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SiteNavigationLinksService } from '@app/core/services/site-navigation/site-navigation-links.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { RadLinkRendererComponent } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';
import { AppResultSearchColumnFields, AppResultSearchGridOptionsFormatter } from '@app/search/gridOptions/app-result-search-grid-options-formatter';
import { OverrideColumnDefinition, OverrideColumnParameters, ColumnMinWidth } from '@app/search/gridOptions/search-grid-options-formatter';

export class AppResultChooserGridOptionsFormatter extends AppResultSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public siteNavigationLinksService: SiteNavigationLinksService,
    public http: HttpClient
  ) {
    super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<AppResultSearchColumnFields> {
    const inclusiveColumns: AppResultSearchColumnFields[] = [
      AppResultSearchColumnFields.Name,
      AppResultSearchColumnFields.Project,
      AppResultSearchColumnFields.Analysis,
      AppResultSearchColumnFields.Size,
      AppResultSearchColumnFields.Created,
      AppResultSearchColumnFields.Owner,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<AppResultSearchColumnFields>[] = [
      {
        headerName: 'Name',
        colId: AppResultSearchColumnFields.Name,
        sortable: false,
        showAlways: true,
        flex: 4,
        minWidth: ColumnMinWidth.RESOURCE,
        cellRendererFramework: RadLinkRendererComponent,
        cellRendererParams: (params) => {
          if (params.data) {
            const appResult = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as IAppResult;
            if (appResult && appResult.AppSession && !appResult.IsDeleted && !appResult.IsArchived) {
              const appSession = appResult.AppSession;
              const fileContainerPath = BsApiEndPoints.getAppResultRoute(appSession.Id, appResult.Id);

              return DataTableUtilities.getRadLinkParams(
                appResult.Name,
                fileContainerPath,
                null,
                null,
                60
              );
            } else if (appResult) {
              return DataTableUtilities.getRadLinkParams(appResult.Name, null, null, null, 60);
            } else {
              return {};
            }
          } else {
            return {};
          }
        },
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}